const WhatsappIcon = () => (
  <svg
    width='25'
    height='24'
    viewBox='0 0 25 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g id='icons8-whatsapp 1'>
      <path
        id='Vector'
        d='M19.4104 4.928C17.5244 3.041 15.0164 2.001 12.3444 2C6.83837 2 2.35737 6.479 2.35537 11.985C2.35437 13.745 2.81437 15.463 3.68837 16.977L2.33337 22L7.56637 20.763C9.02537 21.559 10.6674 21.978 12.3394 21.979H12.3434C17.8484 21.979 22.3294 17.499 22.3324 11.994C22.3344 9.325 21.2964 6.816 19.4104 4.928ZM17.2314 15.554C17.0234 16.137 16.0044 16.699 15.5464 16.74C15.0884 16.782 14.6594 16.947 12.5514 16.116C10.0144 15.116 8.41237 12.515 8.28837 12.349C8.16337 12.182 7.26937 10.996 7.26937 9.768C7.26937 8.54 7.91437 7.936 8.14337 7.687C8.37237 7.437 8.64237 7.375 8.80937 7.375C8.97537 7.375 9.14237 7.375 9.28737 7.381C9.46537 7.388 9.66237 7.397 9.84937 7.812C10.0714 8.306 10.5564 9.54 10.6184 9.665C10.6804 9.79 10.7224 9.936 10.6394 10.102C10.5564 10.268 10.5144 10.372 10.3904 10.518C10.2654 10.664 10.1284 10.843 10.0164 10.955C9.89137 11.079 9.76137 11.215 9.90637 11.464C10.0524 11.714 10.5524 12.531 11.2944 13.192C12.2484 14.042 13.0514 14.305 13.3014 14.431C13.5514 14.556 13.6964 14.535 13.8424 14.368C13.9884 14.202 14.4664 13.64 14.6324 13.39C14.7984 13.14 14.9654 13.182 15.1944 13.265C15.4234 13.348 16.6504 13.952 16.8994 14.077C17.1494 14.202 17.3154 14.264 17.3774 14.368C17.4394 14.471 17.4394 14.971 17.2314 15.554Z'
        fill='#FAFAFA'
      />
    </g>
  </svg>
)

export default WhatsappIcon
